import { render, staticRenderFns } from "./iconMinus.vue?vue&type=template&id=e9b08ba0"
import script from "./iconMinus.vue?vue&type=script&lang=js"
export * from "./iconMinus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports